import kr from '../kr/kr';

export default class ReplaceImageSubpage extends kr.Component {
    init() {
        this.bind();
    }

    bind() {
        const boxWithImages = document.querySelectorAll('.our-bestsellers__single');
        boxWithImages.forEach(el=> {
            el.addEventListener('mouseenter', ()=> {
                el.style.backgroundImage = `url(${el.getAttribute('data-hoverImage')})`;
                el.classList.add('our-bestsellers__single--active');
            })
            el.addEventListener('mouseleave', ()=> {
                el.style.backgroundImage = `url(${el.getAttribute('data-defaultImage')})`;
                el.classList.remove('our-bestsellers__single--active');
            })
        })
    }
}

kr.registerComponent('.our-bestsellers__main', {
    component: ReplaceImageSubpage
});